import React from 'react';

import Features from '@dashboard/enums/features';
import { PAGE_TYPES } from '@/dashboard/enums/page-types';
import usePage from '@dashboard/hooks/usePage';
import CanUseFeature from '@dashboard/components/CanUseFeature';

import EditorSettingsScreen from '../components/EditorSettingsScreen';
import PageEditView from '../components/PageEditView';
import SectionActions from '../components/SectionActions';
import { editorSection } from '../pageEditTabs';

import IntegrationsForm from './PageSettings/components/IntegrationsForm';
import ThirdPartyAnalyticsForm from './PageSettings/components/ThirdPartyAnalyticsForm';

export const getTrackingSections = ({ page } = {}) => {
  return [
    {
      ...editorSection('settings', '/tracking-pixels', { page }),
      component: (
        <CanUseFeature feature={Features.TRACKING_PIXELS}>
          <ThirdPartyAnalyticsForm />
        </CanUseFeature>
      ),
      width: '2xl',
      description: 'Add tracking code from Google Analytics, Meta Pixel or other analytics tools.',
      helpUrl: '/docs/articles/add-tracking-pixels-and-codes-to-your-checkout',
    },
  ];
};

export const getIntegrationsSections = ({ page }) => {
  return [
    {
      ...editorSection('integrations', '/integrations', { page }),
      description: (
        <>
          {page.type === PAGE_TYPES.CHECKOUT && (
            <>
              Connect to your favorite apps and services. These integrations will be triggered when
              a customer completes a purchase.
            </>
          )}

          {page.type === PAGE_TYPES.EVENT && (
            <>
              Connect to your favorite apps and services. These integrations will be triggered when
              someone makes a booking.
            </>
          )}

          {page.type === PAGE_TYPES.FORM && (
            <>
              Connect to your favorite apps and services. These integrations will be triggered when
              a customer submits a form.
            </>
          )}
        </>
      ),
      helpUrl: '/docs/articles/integrations',
      component: <IntegrationsForm />,
    },
  ];
};

export const PageIntegrations = () => {
  const { page } = usePage();
  const [integrations] = getIntegrationsSections({ page });

  return (
    <EditorSettingsScreen
      title={integrations.label}
      description={integrations.description}
      actions={<SectionActions section={integrations} />}
      narrow
    >
      {integrations.component}
    </EditorSettingsScreen>
  );
};

const PageTracking = () => {
  const { page } = usePage();

  return <PageEditView tabs={getTrackingSections({ page })} />;
};

export default PageTracking;
